import { Form } from "@/components/core/forms/form.tsx";
import {
	FormControl,
	FormDescription,
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import { useCaseRecordStatusMutation } from "@/features/case-record/api/queries/case-records-query";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { Button } from "./core/buttons/button";
import { Textarea } from "./core/forms/textarea";
import { useModal } from "./core/modals/use-modal";
import { useModalControl } from "./core/modals/use-modal-controller";

export default function CaseDeferredModal({ data }, { data: CaseRecord }) {
	const { closeModal } = useModalControl();
	const navigate = useNavigate();
	const caseRecordStatusMutation = useCaseRecordStatusMutation();
	const modal = useModal();
	const form = useForm({
		defaultValues: {
			id: data.id,
			status: "deferred_raffling",
			defer_remarks: null,
		},
	});

	const handleSubmit = async (values: CaseRecord) => {
		await caseRecordStatusMutation.mutateAsync(values);
		navigate({
			to: "/case-classification",
		});
		closeModal();
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(handleSubmit)}>
				<div className="flex flex-col w-full col-span-12">
					<FormField
						control={form.control}
						name="defer_remarks"
						render={({ field }) => (
							<FormItem>
								<div className="flex flex-col w-full">
									<FormLabel required>Remarks</FormLabel>
									<FormDescription />
								</div>
								<FormGroup>
									<Textarea {...field} />
								</FormGroup>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div>
				<div className="flex flex-row justify-between w-full gap-2 mt-4">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button>Confirm</Button>
				</div>
			</form>
		</Form>
	);
}
